<template>
	<div
		v-if="loading"
		class="rs-component-loading"
		:class="{
			'full-screen': fullScreen,
			'outer-border': outerBorder,
		}"
	>
		<slot>
			<div class="loading-circle" />
		</slot>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		fullScreen: {
			type: Boolean,
			default: false,
		},
		outerBorder: {
			type: Boolean,
			default: false,
		},
	},
});
</script>

<style scoped lang="scss">
// Fills the nearest positioned ancestor, so **the container has to set
// `position: relative`**. Without one it climbs the tree and covers whatever
// it reaches first, which is usually the whole page — a spinner over an entire
// article while one block waits on one call. `full-screen` is the opt-in for
// when that is genuinely what you want.
.rs-component-loading {
	display: flex;
	position: absolute;
	justify-content: center;
	align-items: center;
	z-index: 10;
	cursor: progress;
	inset: 0 0 0 0;
	background-color: rgb(var(--rs-color-brand-navy) / 50%);
	min-height: 160px;

	.loading-circle {
		border-radius: 50%;
		background-image: url('@/images/loading.gif');
		background-position: center;
		background-size: 50px;
		background-repeat: no-repeat;
		background-color: rgb(var(--rs-color-brand-navy));
		width: 120px;
		height: 120px;
	}

	&.full-screen {
		position: fixed;
		z-index: 999999;
	}

	&.outer-border {
		inset: -10px;
		border-radius: var(--rs-border-radius);
	}
}
</style>
